(function () {
    'use strict';

    angular
        .module('partners')
        .controller('ReportsStudentsListController', ReportsStudentsListController);

    ReportsStudentsListController.$inject = ['ManagePartnersService', 'ExpoService','$uibModal','$q'];

    function ReportsStudentsListController(ManagePartnersService, ExpoService, $uibModal, $q) {
        var vm = this;

        vm.partners = [];

        vm.expos = [];
        vm.expoSelected = [];
        vm.exposAll = [{
            name: '--- All ---'
        }];

        vm.loadExpos                 = loadExpos;
        vm.getByFilter               = getByFilter;
        vm.openRegisteredInformation = openRegisteredInformation;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems   = [];
        vm.currentPage  = null;
        vm.itemsPerPage = [];
        vm.page         = 1;


        activate();


        function setPage(page) {
            vm.currentPage = page;
        };


        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        };


        function activate() {
            vm.loadExpos();
        }


        function loadExpos() {
            vm.query = {};
            vm.query['from_year'] = 2017;

            ExpoService.getExposForSelect(vm.query).then(function(response) {
                vm.expos = vm.exposAll.concat(response.data);
            }).catch(function(err) {
            });
        }


        function getByFilter() {
            vm.query = {};
            vm.query['event_id'] = vm.expoSelected.id;
            vm.query['event_type'] = 'studyad';
            vm.query['page'] = vm.page;

            ManagePartnersService.getByFilter(vm.query).then(function(response) {
                vm.partners = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);

            }).catch(function(err) {
            });
        }


        function openRegisteredInformation(partner) {
            $uibModal.open({
                templateUrl: 'templates/partners/show/registered.modal.html',
                controller: 'PartnerModalController',
                controllerAs:'vm',
                resolve: {
                    partner: function() {
                        return partner;
                    }
                }
            });
        }
    }

})();